var initialize = require('./tripletrax.initialize.js');
var ajax = require('./tripletrax.ajax.js');
var JsNumberFormatter = require('./jsnumberformatter.js').JsNumberFormatter;
var JsNumberFormatterLocales = require('./jsnumberformatter.locale.js').JsNumberFormatterLocales;

module.exports.GLOBALS  =
{
    programmaticClick: false,
    elementToClickAfterSave: null,
    secondElementToClickAfterSave: null, // Für Vorschau bei DataViews muss erst das Element aus Liste angeklickt werden
    showValidationErrorMessageBox: true,
    runningAjaxRequests: [],
    runningTableClickRequests: [],
    runningSaveRequest: null,
    runningCompletenessRequest: null,
    runningCompletenessListRequest: null,
    startNewCompletenessRequest: false,
    timerCompleteness: null,
    timerIntegrity: null,
    integrityControlList: [],
    subControlsList: [],
    contentDetailMasterFields: [],
    contentDetailCourseFields: [],
    ignoreFieldsNameArray: [],
    importRunning: false,
    importQueryRunning: false,
	aggregationRunning: false,
    patientToShow: null,
    examinationToShow: null,
    modelToShow: null,
    showAllActivePatients: null,
    showAllIncompleteMasterPatients: null,
    showAllIncompleteCoursePatients: null,
    showAllIncompleteCourseYearPatients: null,
    controlNameForFocus: null,
    tableNameForFocus: null,
    parentControlForFocus: null,
    controlTabPaneId: null,
    searchString: '',
    mailsSelected: [],
    mailsUnselected: [],
    mailAttachments: [],
    openReport: null,
	queryToShow: null,
	queryToShowTableType: null,
	queryToShowTableName: null,
	completenessToShow: null,
	completenessToShowTableType: null,
	completenessToShowTableName: null,
    course: null,
    courseParent: null,
    master: null,
    masterParent: null,
	questionnaire: null,
	questionnaireParent: null,
    tabForms: [],
	showPatientDataAnonymized: 1,
	progressInterval: null,
	runningBenchDataRequest: null,
	reloadBenchData: false,
    rights: []
};

function updateGlobals(key, value) {
    this.GLOBALS[key] = value;
};

function isUndefined(element) {
    return element === null || element === 'undefined' || typeof (element) === 'undefined' || typeof (element) === false;
}

function getMaster() {
    if (isUndefined(this.GLOBALS.master)) {
        return $('#content-detail-master')
    } else {
        return this.GLOBALS.master;
    }
}

function getCourse() {
	if (isUndefined(this.GLOBALS.course)) {
		return $('#content-detail-course')
	} else {
		return this.GLOBALS.course;
	}
}

function getQuestionnaire() {
	if (isUndefined(this.GLOBALS.questionnaire)) {
	    if (!$('#doc_navigation_tab_questionnaires').hasClass('hide')) {
			return $('#content-detail-questionnaires')
		}
		return null;
	} else {
		return this.GLOBALS.questionnaire;
	}
}

function detachMaster() {
	if (isUndefined(this.GLOBALS.master)) {
	    var master = $('#content-detail-master');
	    this.updateGlobals('masterParent', master.parent());
	    this.updateGlobals('master', master);
		master.detach();
	}
}

function appendMaster() {
	if (!isUndefined(this.GLOBALS.master)) {
		this.GLOBALS.masterParent.append(this.GLOBALS.master);
		this.updateGlobals('masterParent', null);
		this.updateGlobals('master', null);
	}
}

function detachCourse() {
	if (isUndefined(this.GLOBALS.course)) {
		var course = $('#content-detail-course');
		this.updateGlobals('courseParent', course.parent());
		this.updateGlobals('course', course);
		course.detach();
	}
}

function appendCourse() {
	if (!isUndefined(this.GLOBALS.course)) {
		this.GLOBALS.courseParent.append(this.GLOBALS.course);
		this.updateGlobals('courseParent', null);
		this.updateGlobals('course', null);
	}
}

function detachQuestionnaire() {
	if (isUndefined(this.GLOBALS.questionnaire)) {
		var questionnaire = $('#content-detail-questionnaires');
		this.updateGlobals('questionnaireParent', questionnaire.parent());
		this.updateGlobals('questionnaire', questionnaire);
		questionnaire.detach();
	}
}

function appendQuestionnaire() {
	if (!isUndefined(this.GLOBALS.questionnaire)) {
		this.GLOBALS.questionnaireParent.append(this.GLOBALS.questionnaire);
		this.updateGlobals('questionnaireParent', null);
		this.updateGlobals('questionnaire', null);
	}
}

function detachTab(tabId) {
	if (isUndefined(this.GLOBALS.tabForms[tabId])) {
		var tabForm = $('#' + tabId).find('form');
		this.GLOBALS.tabForms[tabId] = tabForm;
		tabForm.detach();
	}
}

function appendTab(tabId) {
	if (!isUndefined(this.GLOBALS.tabForms[tabId])) {
		$('#' + tabId).append(this.GLOBALS.tabForms[tabId]);
		this.GLOBALS.tabForms[tabId] = null;
	}
}

function calculateAge(birth_date, deceased_date) {

    var age;
    if (!isUndefined(deceased_date)) {
        age = round(moment(deceased_date).diff(moment(birth_date), 'years', true), 1);
    } else {
		age = round(moment().diff(moment(birth_date), 'years', true), 1);
	}

    if (age % 1 === 0) {
        var options = new JsNumberFormatterLocales.formatOptions($('#locale').data().locale.split('-')[0]);
        return numberToString(age) + options.decimalSeperatorStr + '0';
    }
    return numberToString(age);
}

function round(value, exp) {
    if (typeof exp === 'undefined' || +exp === 0)
        return Math.round(value);

    value = +value;
    exp = +exp;

    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0))
        return NaN;

    // Shift
    value = value.toString().split('e');
    value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp)));

    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp));
}

function complementDateString(date, format) {

    var dateArray = date.split('.');

    if (/^MM\/YYYY$/.test(format)) {
        dateArray = date.split('/');
    }

    if (/^DD\.MM\.YYYY$/.test(format)) {

        if (dateArray[0].length === 1) {
            dateArray[0] = '0' + dateArray[0];
        }
        if (dateArray.length > 1 && dateArray[1].length === 1) {
            dateArray[1] = '0' + dateArray[1];
        }

        if (dateArray.length === 1 || dateArray[1] == '') {
            dateArray[1] = moment().format('MM.YYYY');
        } else {
            if (dateArray.length === 2 || (dateArray.length > 2 && dateArray[dateArray.length - 1] == '')) {
                if (dateArray.length === 2) {
                    dateArray[dateArray.length] = moment().format('YYYY');
                } else {
                    dateArray[dateArray.length - 1] = moment().format('YYYY');
                }
            } else if (dateArray.length > 2 && dateArray[dateArray.length - 1].length === 2) {
                try {
                    var year = parseInt(dateArray[dateArray.length - 1]);
                    dateArray[dateArray.length - 1] = (year + (year > (parseInt(moment().format('YY')) + 1) ? 1900 : 2000)).toString();
                } catch (NaNError) {
                }
            }
        }

        date = dateArray.join('.');
    } else if (/^MM\/YYYY$/.test(format)) {

        if (dateArray[0].length === 1) {
            dateArray[0] = '0' + dateArray[0];
        }
        if (dateArray.length === 1) {
            dateArray[1] = moment().format('YYYY');
        } else if (dateArray.length > 1 && dateArray[dateArray.length - 1].length === 2) {
            try {
                var year = parseInt(dateArray[dateArray.length - 1]);
                dateArray[dateArray.length - 1] = (year + (year > (parseInt(moment().format('YY')) + 1) ? 1900 : 2000)).toString();
            } catch (NaNError) {
            }
        }

        date = dateArray.join('/');
    } else if (/^YYYY$/.test(format)) {

        if (dateArray.length === 1 && dateArray[dateArray.length - 1].length === 2) {
            try {
                var year = parseInt(dateArray[dateArray.length - 1]);
                dateArray[dateArray.length - 1] = (year + (year > (parseInt(moment().format('YY')) + 1) ? 1900 : 2000)).toString();
            } catch (NaNError) {
            }
        }

        date = dateArray.join('/');
    }

    return date;
}

function dateToString(date) {
    if (isUndefined(date) || date === '') {
        return '';
    }
    return moment(date).format('YYYY-MM-DD');
}

function dateToTimeString(date) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
}

function dateToTimepickerString(date) {
    return moment(date).format('HH:mm');
}

function stringToDate(dateString) {
    if (dateString === null || dateString === '' || dateString === '0000-00-00' || dateString === '0000-00-00 00:00:00') {
        return null;
    }
    if (dateString === 'today') {
        return moment().toDate();
    }
    return moment(dateString).toDate();
}

function stringToUTCDate(dateString) {

    if (dateString === null || dateString === '' || dateString === '0000-00-00' || dateString === '0000-00-00 00:00:00') {
        return null;
    }

    return moment.utc(dateString).valueOf();
}

function dateToLocaleFormatString(dateString, format) {
    if (dateString === null || dateString === '') {
        return '';
    }

    return moment(dateString).locale($('#locale').data().locale).format(format);
}

function dateToLocaleString(dateString) {
    if (dateString === null || dateString === '') {
        return '';
    }

    return moment(dateString).locale($('#locale').data().locale).format('L');
}

function dateToLocaleTimeString(dateString, asHTML) {
    var addHTML = true;
    if (!isUndefined(asHTML)) {
        addHTML = asHTML;
    }
    if (dateString === null || dateString === '') {
        return '';
    }

    if (addHTML) {
        return moment(dateString).locale($('#locale').data().locale).format('L') + '&nbsp;&nbsp;' + moment(dateString).locale($('#locale').data().locale).format('LT');
    }
    return moment(dateString).locale($('#locale').data().locale).format('L') + '  ' + moment(dateString).locale($('#locale').data().locale).format('LT');
}

function dateToLocaleLongTimeString(dateString, withoutDay) {
    if (dateString === null || dateString === '') {
        return '';
    }
    if (!isUndefined(withoutDay) && withoutDay) {
        return moment(dateString).locale($('#locale').data().locale).format('LLL');
    }

    return moment(dateString).locale($('#locale').data().locale).format('LLLL');
}

function getLocaleDateFormat() {
    return moment().locale($('#locale').data().locale)._locale._longDateFormat.L;
}

function getLocaleDateFormatMask(dateFormat) {
    if (!isUndefined(dateFormat)) {
        return dateFormat.replace('DD', '99').replace('MM', '99').replace('YYYY', '9999');
    }
    return '?' + moment().locale($('#locale').data().locale)._locale._longDateFormat.L.replace('DD', '99').replace('MM', '99').replace('YYYY', '9999');
}

function getExaminationDateFormat() {
    if (!isUndefined($('#content').find('.tt-data-collection-type.select2-hidden-accessible').select2('data')) && $('#content').find('.tt-data-collection-type.select2-hidden-accessible').select2('data').length) {
        return $('#content').find('.tt-data-collection-type.select2-hidden-accessible').select2('data')[0].examinationdateFormat;
    }
    return '';
}

function getExaminationDateString(date, format, asHTML) {
    var addHTML = true;
    if (!isUndefined(asHTML)) {
        addHTML = asHTML;
    }
    var dateToDisplay = null;
    if (format === 'date') {
        dateToDisplay = dateToLocaleString(date);
    } else if (format === 'year') {
        dateToDisplay = moment(date).locale($('#locale').data().locale).format('YYYY');
    } else if (format === 'month_year') {
        dateToDisplay = moment(date).locale($('#locale').data().locale).format('MM') + '/' + moment(date).locale($('#locale').data().locale).format('YYYY');
    } else if (format === 'quarter_year') {
        dateToDisplay = moment(date).locale($('#locale').data().locale).format('Q') + '/' + moment(date).locale($('#locale').data().locale).format('YYYY');
    } else {
        dateToDisplay = dateToLocaleTimeString(date, addHTML);
    }
    return dateToDisplay;
}

function getMomentFormat(dateFormat) {
    return dateFormat.replace('dd', 'DD').replace('mm', 'MM').replace('yy', 'YYYY');
}

function getLocaleTimeFormat() {
    return moment().locale($('#locale').data().locale)._locale._longDateFormat.LT;
}

function getLocaleNumberString(number, decimals) {

    try {
        return numberToString(stringToNumber(number), decimals);
    } catch (NaNError) {
        return number;
    }
}

function stringToNumber(value) {
    try {
        if (value === '') {
            return '';
        }
        var options = new JsNumberFormatterLocales.parseOptions($('#locale').data().locale.split('-')[0]);
        return JsNumberFormatter.parseNumberSimple(value, options, false).valueOf();
    } catch (NaNError) {
        throw new NaNError();
    }
}

function numberToString(number, decimals) {
    try {
        if (!isUndefined(decimals) && decimals === 0) {
            number = round(number, 0);
            decimals = null;
        }

        var options = new JsNumberFormatterLocales.formatOptions($('#locale').data().locale.split('-')[0]);
        if (!isUndefined(decimals) && decimals > 0) {
            var decimalsString = '';
            for (var i = 0; i < decimals; i++) {
                decimalsString += '0';
            }
            options.specifyDecimalMask(decimalsString);
        }
        var sign = '';
        if (number < 0) {
            sign = '-';
            number = number * (-1);
        }
        var numberString = JsNumberFormatter.formatNumber(number, options, false);
        if (!/^[0-9]/.test(numberString)) {
            numberString = '0' + numberString;
        }

        return sign + numberString;

    } catch (NaNError) {
        return '';
    }
}

function getDecimalSeparator() {
    var options = new JsNumberFormatterLocales.formatOptions($('#locale').data().locale.split('-')[0]);
    return options['decimalSeperatorStr'];
}

function getSerializedFormData(form) {
    return getSerializedFormDataWithoutIgnore(form, '', false);
}

function getSerializedFormDataWithoutIgnore(form, ignore, addEmptyValues) {
    var arrKeyValuePairs = serializeFormData(form, ignore, addEmptyValues);

    $(form).find('[data-database-table-name]').each(function (i, table) {
        if ($(table).hasClass('tt-accordion')) {
            $(table).find('.tt-accordion-panel').each(function (j, row) {
                arrKeyValuePairs.push($(table).data().databaseTableName + '_rowid__' + $(row).data().rowId + "=" + $(row).data().dataId);
            });
        } else {
            var dataTable = $(table).DataTable();
            for (var l = 0; l < dataTable.data().length; l++) {
                var row = $(dataTable.row(l).node());
                arrKeyValuePairs.push($(table).data().databaseTableName + '_rowid__' + row.data().rowId + "=" + row.data().dataId);
                jQuery.merge(arrKeyValuePairs, serializeFormData(row, ignore, addEmptyValues));
            }
        }
    });


    return arrKeyValuePairs.join("&");
}

function serializeFormData(form, ignore, addEmptyValues) {

    var rCRLF = /\r?\n/g;
    var data = '';
    var ignoreSelector = '[name]';
    var ignoreSelectorDisabled = '';

    if (ignore !== '') {
        ignoreSelector = 'input:not(' + ignore + '),select:not(' + ignore + ')';
        ignoreSelectorDisabled = '[name]:disabled:not(' + ignore + ')';
    }
    //console.time('serialize2');
    var arrKeyValuePairs = [];
    var keyArray = [];
    var selector = ignoreSelector;
    if (ignoreSelectorDisabled !== '') {
        selector = ignoreSelector + ',' + ignoreSelectorDisabled;
    }
    jQuery.each($(form).find(selector), function(i, element) {
        var isRadioCheckbox = $(element).is(':radio') || $(element).is(':checkbox');
        if (!isUndefined(element.name) && element.name !== '') {
            var val = jQuery(this).val();
            if ($(element).hasClass('tt-select2', 'select2-hidden-accessible')) {
                val = $(element).select2('val');
            } else if ($(element).hasClass('datepicker') && val.replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') === '') {
                val = '';
            }

            if (val !== null && val !== '' && (!isRadioCheckbox || (isRadioCheckbox && $(element).is(':checked')))) {
                var key = element.name;
                var value = '';
                if (jQuery.isArray(val)) {
                    jQuery.map(val, function (val) {
                        if (value !== '') {
                            value += '|';
                        }
                        value += val.replace(rCRLF, "\r\n");
                    });
                } else {
                    value = val.replace(rCRLF, "\r\n");
                }

                if ($(element).hasClass('datepicker')) {
                    var picker = $(element).data('picker');
                    value = dateToString(picker.getDate());
                }
                if ($(element).hasClass('tt-input-decimal')) {
                    try {
                        value = stringToNumber(value);
                    } catch (NaNError) {
                    }
                }
                if ($(element).length && !isUndefined(element.dataset.calculatedValue) && element.dataset.calculatedValue !== '') {
                    try {
                        value = stringToNumber(element.dataset.calculatedValue);
                    } catch (NaNError) {
                        value = element.dataset.calculatedValue;
                    }
                }
                if (keyArray.indexOf(key) >= 0) {
                    arrKeyValuePairs = jQuery.grep(arrKeyValuePairs, function(element) {
                        var pattern = new RegExp("^" + encodeURIComponent(key) + "=");
                        return !pattern.test(element);
                    });
                } else {
                    keyArray.push(key);
                }
                arrKeyValuePairs.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
            } else {
                if (addEmptyValues) {
                    if (keyArray.indexOf(element.name) < 0) {
                        arrKeyValuePairs.push(encodeURIComponent(element.name) + "=");
                        keyArray.push(element.name);
                    }
                }
            }
        }
    });

    //console.timeEnd('serialize4');
    //console.time('serialize5');
    $(form).find('.tt-input-dropdown').each(function () {
        if (ignore !== '') {
            if ($(this).parent().find(ignoreSelector).length === 0) {
                return;
            }
        }
        if ($(this).find('li.active').length) {
            var formatValue = $(this).find('li.active').find('a').data().formatValue;
            var fieldName = $(this).parent().find('input').attr('name');
            var fieldValue = $(this).parent().find('input').val();

            if (fieldValue === '' || formatValue === 'value' || formatValue === 'full') {
                formatValue = '';
            }

            if (/__/.test(fieldName)) {
                var name = fieldName.substring(0, fieldName.indexOf("__"));
                var name_appendix = fieldName.substring(fieldName.indexOf("__"));
                arrKeyValuePairs.push(encodeURIComponent(name + '_format' + name_appendix) + '=' + encodeURIComponent(formatValue));
            } else {
                arrKeyValuePairs.push(encodeURIComponent(fieldName + '_format') + '=' + encodeURIComponent(formatValue));
            }

            if (isFormatValue(formatValue)) {
                arrKeyValuePairs = jQuery.grep(arrKeyValuePairs, function(value) {
                    return value.indexOf(encodeURIComponent(fieldName) + '=') !== 0;
                });
                if (addEmptyValues) {
                    arrKeyValuePairs.push(encodeURIComponent(fieldName) + '=');
                }
            }
        }
    });

    //console.timeEnd('serialize5');
    return arrKeyValuePairs;
}

function setValueForInputWithDropDownField(element, value, changeDisabledState) {
    if (value !== '') {
        if (value === 'not_collected') {
            setInputNotCollectedValue(element.parent().find('a[data-format-value="' + value + '"]'));
        } else if (value === 'unknown') {
            setInputUnknownValue(element.parent().find('a[data-format-value="' + value + '"]'));
        } else if (value === 'not_measurable') {
            setInputNotMeasurableValue(element.parent().find('a[data-format-value="' + value + '"]'));
        } else if (value === 'continuing') {
            setInputContinuingValue(element.parent().find('a[data-format-value="' + value + '"]'));
        } else if (value === 'unlimited') {
            setInputUnlimitedValue(element.parent().find('a[data-format-value="' + value + '"]'));
        } else {
            if (element.parent().hasClass('tt-datepicker') && element.parent().find('a[data-format-value="' + value + '"]').length) {
                setDatePickerDropDownValue(element.parent().find('a[data-format-value="' + value + '"]'), changeDisabledState);
            } else {
                setInputDropDownValue(element.parent().find('a[data-format-value="' + value + '"]'), changeDisabledState);
            }
        }

        var currentDisplayDecimals = '';
        if (element.parent().find('.tt-input-dropdown').length) {
            if (element.parent().find('li.active').length) {
                currentDisplayDecimals = element.parent().find('li.active').find('a').data().displayDecimals;
            }
        }
        $(element).parents('.input').find('input').data('displayDecimals', currentDisplayDecimals);
    }
}

function getValueFromInputWithDropDownField(element) {
    var selected_value = '';

    element.parent().parent().find('.tt-input-dropdown').each(function () {
        if ($(this).find('li.active').length) {
             selected_value = $(this).find('li.active').find('a').data().formatValue;
             return false;
        }
    });

    return selected_value;
}

function setDatePickerDropDownValue(element, changeDisabledState) {

    var input = $(element).parents('.input').find('input');
    var picker = $(input).data('picker');
    var currentDate = picker.getDate();
    var prevFormatValue = $(element).parents('ul.dropdown-menu').find('li.active').find('a').data().formatValue;

    $(element).parents('ul.dropdown-menu').find('li').removeClass('active');
    $(element).parent().addClass('active');

    if (changeDisabledState) {
		input.removeAttr('disabled');
    }
	input.removeClass('tt-input-disabled');

    if ($(element).hasClass('tt-select-date-full')) {
		input.data('dateformat', getLocaleDateFormat());
		input.mask(getLocaleDateFormatMask(), { placeholder: '_' });
    } else if ($(element).hasClass('tt-select-date-month-year')) {
		input.data('dateformat', 'MM/YYYY');
		input.mask('?99/9999', { placeholder: '_' });
    } else if ($(element).hasClass('tt-select-date-year')) {
		input.data('dateformat', 'YYYY');
		input.mask('?9999', { placeholder: '_' });
    }

    picker.config({ format: input.data('dateformat') });

    if (prevFormatValue === 'not_collected' || prevFormatValue === 'unknown' || prevFormatValue === 'continuing') {
		input.val('');
    } else {
        picker.setDate(currentDate);
    }
}

function setDatePickerValue(picker, selectedDate) {
    var format = picker._o.format;

    var currentDateString = complementDateString(selectedDate, format).replace(/_/g, '');
    if (selectedDate.replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') === '') {
        currentDateString = '';
    }

    if (currentDateString !== '' && moment(currentDateString, getMomentFormat(format)).isValid()) {
        picker.setMoment(moment(currentDateString, getMomentFormat(format)));
    } else {
        picker.setDate(null);
        $(picker._o.field).val(currentDateString);
    }
}

function setInputDropDownValue(element, changeDisabledState) {

    if (!isUndefined($(element).parents('ul.dropdown-menu').find('li.active').find('a').data())) {
		var input = $(element).parents('.input').find('input');
        var prevFormatValue = $(element).parents('ul.dropdown-menu').find('li.active').find('a').data().formatValue;

        $(element).parents('ul.dropdown-menu').find('li').removeClass('active');
        $(element).parent().addClass('active');

        if (changeDisabledState) {
			input.removeAttr('disabled');
        }
        $(element).parents('.input').find('.input').find('i').text($(element).text());
        if (prevFormatValue === 'not_collected' || prevFormatValue === 'unknown' || prevFormatValue === 'not_measurable' || prevFormatValue === 'unlimited') {
			input.val('');
        }
		input.removeClass('tt-input-disabled');
    }
}

function setInputUnknownValue(element) {
    $(element).parents('ul.dropdown-menu').find('li').removeClass('active');
    $(element).parent().addClass('active');

	var input = $(element).parents('.input').find('input');
	input.prop('disabled', 'disabled');
	input.val(trans('tripletrax.unknown'));
	input.addClass('tt-input-disabled');
}

function setInputNotCollectedValue(element) {
    $(element).parents('ul.dropdown-menu').find('li').removeClass('active');
    $(element).parent().addClass('active');

	var input = $(element).parents('.input').find('input');
    input.prop('disabled', 'disabled');
    input.val(trans('tripletrax.not_collected'));
    input.addClass('tt-input-disabled');
}

function setInputNotMeasurableValue(element) {
    $(element).parents('ul.dropdown-menu').find('li').removeClass('active');
    $(element).parent().addClass('active');

	var input = $(element).parents('.input').find('input');
    input.prop('disabled', 'disabled');
    input.val(trans('tripletrax.not_measurable'));
    input.addClass('tt-input-disabled');
}

function setInputContinuingValue(element) {
    $(element).parents('ul.dropdown-menu').find('li').removeClass('active');
    $(element).parent().addClass('active');

	var input = $(element).parents('.input').find('input');
    input.prop('disabled', 'disabled');
    input.val(trans('tripletrax.continuing'));
    input.addClass('tt-input-disabled');
}

function setInputUnlimitedValue(element) {
    $(element).parents('ul.dropdown-menu').find('li').removeClass('active');
    $(element).parent().addClass('active');

	var input = $(element).parents('.input').find('input');
    input.prop('disabled', 'disabled');
    input.val(trans('tripletrax.unlimited'));
    input.addClass('tt-input-disabled');
}

function arrayIntersect(array1, array2) {
    return $.grep(array1, function (i) {
        return $.inArray(i, array2) > -1;
    });
};

function setHtmlData(element, data, doInitializeElements) {
    //console.time('setHtmlData1');
    element.empty();
    element.html(data);
    //console.timeEnd('setHtmlData1');
    //console.time('setHtmlData2');
    element.find('.tt-input-decimal').each(function () {
        if ($(this).val() !== '') {
            $(this).val(numberToString(parseFloat($(this).val())));
        }
    });
    element.find('.tt-format-t').each(function () {
        $(this).text(dateToLocaleTimeString(parseInt($(this).text()), false));
    });
    element.find('.tt-format-d').each(function () {
        if ($(this).hasClass('tt-examinationdate')) {
            $(this).text(dateToLocaleTimeString($(this).text(), false));
        } else {
            $(this).text(dateToLocaleString($(this).text()));
        }
    });
    element.find('.tt-format-long-d').each(function () {
        $(this).text(dateToLocaleLongTimeString($(this).text(), false));
    });
    element.find('.tt-format-d-mm-yy').each(function () {
        $(this).text(dateToLocaleFormatString($(this).text(), 'MM/YYYY'));
    });
    element.find('.tt-format-d-yy').each(function () {
        $(this).text(dateToLocaleFormatString($(this).text(), 'YYYY'));
    });
    element.find('.tt-format-n').each(function () {
        $(this).text(numberToString(parseFloat($(this).text())));
    });
    element.find('.tt-format-examinationdate').each(function () {
        $(this).text(getExaminationDateString($(this).text(), $(this).data().format, false));
    });
    //console.timeEnd('setHtmlData2');
    //console.time('setHtmlData3');
    if (doInitializeElements) {
        initialize.initializeElements(element, true, false);
    }
    //console.timeEnd('setHtmlData3');
}

function setIDATData(control) {
    return $.Deferred(function (defer) {
        if ($(control).find('.idat-token').length) {

            var genderMatchValues = $('#gender_values').data().matchValues;
            var genderValues = $('#gender_values').data().values;

            if ($(control).find('.idat-token').val() !== '') {
                ajax.ajaxCallDeferredExtended($(control).find('.idat-token').data().url, 'GET', 'tokenId=' + encodeURIComponent($(control).find('.idat-token').val()), false, true, 'application/x-www-form-urlencoded; charset=UTF-8', null, false)
                    .done(function (data) {
                        if (ajax.ajaxSucceeded(data)) {

                            jQuery.each($(control).find('.tt-pseudonym,.tt-pseudonym-new,.tt-pseudonym-questionnaire'), function(i, element) {
                                jQuery.each(data, function (k, idat) {
                                    if (idat["ids"][0]["idString"] === $(element).text()) {

                                        var patientname = idat["fields"]["nachname"];
                                        var prename = idat["fields"]["vorname"];
                                        var birthDate = idat["fields"]["geburtsjahr"] + '-' + ('00' + idat["fields"]["geburtsmonat"]).substr(idat["fields"]["geburtsmonat"].length) + '-' + ('00' + idat["fields"]["geburtstag"]).substr(idat["fields"]["geburtstag"].length);
                                        var gender = idat["fields"]["geschlecht"];
                                        if (gender === 'M' && !isUndefined(genderMatchValues["male"])) {
                                            gender = genderMatchValues["male"];
                                        } else if (gender === 'W' && !isUndefined(genderMatchValues["female"])) {
                                            gender = genderMatchValues["female"];
                                        }
                                        var deceased = $(element).data('deceased');
                                        var deceasedDate = null;
                                        var deceasedDateFormat = null;
                                        var deceasedText = '';
                                        if (deceased) {
                                            deceasedDate = $(element).data('deceasedDate');
                                            deceasedDateFormat = $(element).data('deceasedDateFormat');
                                            if (deceasedDate !== null) {
                                                if (deceasedDateFormat === 'yy' || deceasedDateFormat === 'mm/yy') {
                                                    deceasedText += ' - † ' + dateToLocaleFormatString(deceasedDate, deceasedDateFormat.replace('yy', 'yyyy').toUpperCase());
                                                } else {
                                                    deceasedText += ' - † ' + dateToLocaleString(deceasedDate);
                                                }
                                            } else {
                                                if (deceasedDateFormat !== null) {
                                                    if (deceasedDateFormat === 'unknown') {
                                                        deceasedText += ' - † ' + trans('tripletrax.unknown');
                                                    } else if (deceasedDateFormat === 'not_collected') {
                                                        deceasedText += ' - † ' + trans('tripletrax.not_collected');
                                                    } else if (deceasedDateFormat === 'continuing') {
                                                        deceasedText += ' - † ' + trans('tripletrax.continuing');
                                                    }
                                                } else {
                                                    deceasedText += ' - † ' + trans('tripletrax.unknown');
                                                }
                                            }
                                        }
                                        var space = ' ';
                                        var lineBreak = '';
                                        if ($(element).hasClass('tt-pseudonym-new')) {
                                            lineBreak = '</br>';
                                            space = '';
                                        }

                                        $(element).data('prename', prename);
                                        $(element).data('name', patientname);
                                        $(element).data('birth-date-display', dateToLocaleString(birthDate));
										if ($(element).hasClass('tt-pseudonym-questionnaire')) {
											$(element).html(patientname + ', ' + prename + ' - *' + space + dateToLocaleString(birthDate));
										} else {
											$(element).html(patientname + ', ' + prename + ' - *' + space + dateToLocaleString(birthDate) + deceasedText + ' ' + lineBreak + '(' + calculateAge(birthDate, deceasedDate) + ' - ' + trans('tripletrax.years_age') + ') - ' + genderValues[gender]);
										}

                                        if (!isUndefined($(element).parents('.user'))) {
                                            if (gender.toString() === genderMatchValues["female"].toString()) {
                                                if ($(element).parents('.user').find('.tt-female').length) {
                                                    $(element).parents('.user').find('.tt-female').removeClass('hide');
                                                }
                                            } else {
                                                if ($(element).parents('.user').find('.tt-male').length) {
                                                    $(element).parents('.user').find('.tt-male').removeClass('hide');
                                                }
                                            }
                                        }
                                    }
                                });
                            });
                        }
                        defer.resolve();
                    });
            } else {
                jQuery.each($(control).find('.tt-pseudonym,.tt-pseudonym-new'), function(i, element) {

                    var birthDate = $(element).data().birthDate;
                    var gender = $(element).data().gender;
                    var deceased = $(element).data('deceased');
                    var deceasedDate = null;
                    var deceasedDateFormat = null;
                    var deceasedText = '';
                    if (deceased) {
                        deceasedDate = $(element).data('deceasedDate');
                        deceasedDateFormat = $(element).data('deceasedDateFormat');
                        if (deceasedDate !== null) {
                            if (deceasedDateFormat === 'yy') {
                                deceasedText += ' - † ' + dateToLocaleFormatString(deceasedDate, deceasedDateFormat.replace('yy', 'yyyy').toUpperCase());
                            } else {
                                deceasedText += ' - † ' + moment(deceasedDate).format('MM/YYYY');
                            }
                        } else {
                            if (deceasedDateFormat !== null) {
                                if (deceasedDateFormat === 'unknown') {
                                    deceasedText += ' - † ' + trans('tripletrax.unknown');
                                } else if (deceasedDateFormat === 'not_collected') {
                                    deceasedText += ' - † ' + trans('tripletrax.not_collected');
                                } else if (deceasedDateFormat === 'continuing') {
                                    deceasedText += ' - † ' + trans('tripletrax.continuing');
                                }
                            } else {
                                deceasedText += ' - † ' + trans('tripletrax.unknown');
                            }
                        }
                    }
                    var lineBreak = '';
                    var space = ' ';
                    if ($(element).hasClass('tt-pseudonym-new')) {
                        lineBreak = '</br>';
                        space = '';
                    }
					if ($(element).hasClass('tt-pseudonym-questionnaire')) {
						$(element).html('[' + $(element).text() + '] - *' + space + moment(birthDate).format('MM/YYYY'));
					} else {
						$(element).html('[' + $(element).text() + '] - *' + space + moment(birthDate).format('MM/YYYY') + deceasedText + ' ' + lineBreak + '(' + calculateAge(birthDate, deceasedDate) + ' - ' + trans('tripletrax.years_age') + ') - ' + genderValues[gender]);
					}

                    if (gender.toString() === genderMatchValues["female"].toString()) {
                        if ($(element).parents('.user').find('.tt-female').length) {
                            $(element).parents('.user').find('.tt-female').removeClass('hide');
                        }
                    } else {
                        if ($(element).parents('.user').find('.tt-male').length) {
                            $(element).parents('.user').find('.tt-male').removeClass('hide');
                        }
                    }
                });
                defer.resolve();
            }
        } else {
            defer.resolve();
        }
    }).promise();
}

function isIDATField(matchFieldName) {

    var idatFields = ['pseudonym', 'patientname', 'street', 'prename', 'city' ,'birth_name', 'postal_code', 'birth_date', 'birth_city', 'gender'];
    return jQuery.inArray(matchFieldName, idatFields) !== -1;
}

function isIDATFieldInDatabase(matchFieldName) {

    var idatFields = ['patientname', 'street', 'prename', 'city' ,'birth_name', 'postal_code', 'birth_city'];
    return jQuery.inArray(matchFieldName, idatFields) !== -1;
}

function isIDATInputField(matchFieldName) {
    var idatFields = ['pseudonym', 'patientname', 'street', 'prename', 'city' ,'birth_name', 'postal_code', 'birth_city'];
    return jQuery.inArray(matchFieldName, idatFields) !== -1;
}

function isIDATRadioComboField(matchFieldName) {
    var idatFields = ['gender'];
    return jQuery.inArray(matchFieldName, idatFields) !== -1;
}

function isIDATDatePanelField(matchFieldName) {
    var idatFields = ['birth_date'];
    return jQuery.inArray(matchFieldName, idatFields) !== -1;
}

function isMatchFieldInDatabase(matchFieldName) {

    var matchFields = [''];
    return jQuery.inArray(matchFieldName, matchFields) !== -1;
}

function getIgnoreFields() {

    return '[data-match-field="pseudonym"][data-match-field="patientname"],[data-match-field="street"],[data-match-field="prename"],[data-match-field="city"],[data-match-field="birth_name"],[data-match-field="postal_code"],[data-match-field="birth_date"],[data-match-field="birth_city"],[data-match-field="gender"]';
}

function getIgnoreFieldsNameArray() {

    if (isUndefined(this.ignoreFieldsNameArray) || this.ignoreFieldsNameArray.length === 0) {
		this.ignoreFieldsNameArray = [];
        if ($('[data-match-field="patientname"]').length) {
            this.ignoreFieldsNameArray.push($('[data-match-field="patientname"]').attr('name'));
            this.ignoreFieldsNameArray.push($('[data-match-field="patientname"]').attr('name') + '_format');
        }
        if ($('[data-match-field="street"]').length) {
            this.ignoreFieldsNameArray.push($('[data-match-field="street"]').attr('name'));
            this.ignoreFieldsNameArray.push($('[data-match-field="street"]').attr('name') + '_format');
        }
        if ($('[data-match-field="prename"]').length) {
            this.ignoreFieldsNameArray.push($('[data-match-field="prename"]').attr('name'));
            this.ignoreFieldsNameArray.push($('[data-match-field="prename"]').attr('name') + '_format');
        }
        if ($('[data-match-field="city"]').length) {
            this.ignoreFieldsNameArray.push($('[data-match-field="city"]').attr('name'));
            this.ignoreFieldsNameArray.push($('[data-match-field="city"]').attr('name') + '_format');
        }
        if ($('[data-match-field="birth_name"]').length) {
            this.ignoreFieldsNameArray.push($('[data-match-field="birth_name"]').attr('name'));
            this.ignoreFieldsNameArray.push($('[data-match-field="birth_name"]').attr('name') + '_format');
        }
        if ($('[data-match-field="postal_code"]').length) {
            this.ignoreFieldsNameArray.push($('[data-match-field="postal_code"]').attr('name'));
            this.ignoreFieldsNameArray.push($('[data-match-field="postal_code"]').attr('name') + '_format');
        }
        if ($('[data-match-field="birth_date"]').length) {
            this.ignoreFieldsNameArray.push($('[data-match-field="birth_date"]').attr('name'));
            this.ignoreFieldsNameArray.push($('[data-match-field="birth_date"]').attr('name') + '_format');
        }
        if ($('[data-match-field="birth_city"]').length) {
            this.ignoreFieldsNameArray.push($('[data-match-field="birth_city"]').attr('name'));
            this.ignoreFieldsNameArray.push($('[data-match-field="birth_city"]').attr('name') + '_format');
        }
        if ($('[data-match-field="gender"]').length) {
            this.ignoreFieldsNameArray.push($('[data-match-field="gender"]').attr('name'));
            this.ignoreFieldsNameArray.push($('[data-match-field="gender"]').attr('name') + '_format');
        }
    }
    return this.ignoreFieldsNameArray;
}

function isFormatValue(value) {

    var formatValues = ['unknown', 'not_collected', 'continuing', 'not_measurable', 'unlimited'];
    return jQuery.inArray(value, formatValues) !== -1;
}

function htmlSpecialChars(string) {

    var map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;',
        'ä': '&auml;',
        'ü': '&uuml;',
        'ö': '&ouml;',
        'Ä': '&Auml;',
        'Ü': '&Uuml;',
        'Ö': '&Ouml;',
        'ß': '&szlig;'
    };

    return string.replace(/[&<>"']/g, function(string) { return map[string]; });
}

function isIgnoreFlagForIntegrityCheck(flagName) {

    var ignoreFlagNames = ['import', 'import_query', 'integrity_check', 'completeness_check'];
    return jQuery.inArray(flagName, ignoreFlagNames) !== -1;
}

function blockUI(options) {
	options = $.extend(true, {}, options);
	var html = '';
	if (options.animate) {
		html = '<div class="loading-message ' + (options.boxed ? 'loading-message-boxed' : '') + '">' + '<div class="block-spinner-bar"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>' + '</div>';
	} else if (options.iconOnly) {
		html = '<div class="loading-message ' + (options.boxed ? 'loading-message-boxed' : '') + '"><i class="fad fa-spinner fa-spin fa-3x fa-fw"></i></div>';
	} else if (options.textOnly) {
		html = '<div class="loading-message ' + (options.boxed ? 'loading-message-boxed' : '') + '"><span>&nbsp;&nbsp;' + (options.message ? options.message : 'LOADING...') + '</span></div>';
	} else if (options.none) {
	    html = '';
	} else {
		html = '<div class="loading-message ' + (options.boxed ? 'loading-message-boxed' : '') + '"><i class="fad fa-spinner fa-spin fa-3x fa-fw"></i><span>&nbsp;&nbsp;' + (options.message ? options.message : 'LOADING...') + '</span></div>';
	}

	if (options.target) { // element blocking
		var el = $(options.target);
		if (el.height() <= ($(window).height())) {
			options.cenrerY = true;
		}
		el.block({
			message: html,
			baseZ: options.zIndex ? options.zIndex : 10000,
			centerY: options.cenrerY !== undefined ? options.cenrerY : false,
			css: {
				top: '10%',
				border: '0',
				padding: '0',
				backgroundColor: 'none'
			},
			overlayCSS: {
				backgroundColor: options.overlayColor ? options.overlayColor : '#555',
				opacity: options.boxed ? 0.5 : 0.1,
				cursor: 'wait'
			}
		});
	} else { // page blocking
		$.blockUI({
			message: html,
			baseZ: options.zIndex ? options.zIndex : 10000,
			css: {
				border: '0',
				padding: '0',
				backgroundColor: 'none'
			},
			overlayCSS: {
				backgroundColor: options.overlayColor ? options.overlayColor : '#555',
				opacity: options.boxed ? 0.5 : 0.1,
				cursor: 'wait'
			}
		});
	}
}

function unblockUI(target) {
	if (target) {
		$(target).unblock({
			onUnblock: function() {
				$(target).css('position', '');
				$(target).css('zoom', '');
			}
		});
	} else {
		$.unblockUI();
	}
}

function showProgressbar(time, control, text) {

	blockUI({ none: true });
	control.html(
		'<div class="tt-content-course">' +
		'<article class="tt-nav-content-article tt-nav-tab-content col-xs-8 col-sm-9 col-md-10 col-lg-11 col-xlg-11 margin-bottom-20">' +
		'<label class="tt-wait-test-label"><p><i class="fad fa-circle-notch fa-spin"></i> ' + text + '</p></label>' +
		'<label class="tt-wait-test"><div class="progress">' +
		'<div id="wait_progress" class="progress-bar progress-bar-primary" role="progressbar" style="width: 0%;"></div>' +
		'</div></label></article></div>');

	var n = +(new Date);
	$('#wait_progress').css('width', '0%');
	var interval = setInterval(function() {
		var diff = +(new Date) - n;
		var percent = diff * 90 / time;
		percent = (percent / 10) + 1;
		percent = Math.floor(Math.log10(percent) * 100);
		if (percent > 100) {
		    percent = 100;
        }

		$('#wait_progress').css('width', percent + '%').text(percent.toString() + "%");
	}, 1);

	this.updateGlobals('progressInterval', interval);
}

function hideProgressbar() {

	unblockUI();
    if (!isUndefined(this.GLOBALS.progressInterval)) {
		clearInterval(this.GLOBALS.progressInterval);
        // console.log('hideProgressbar');
		// this.GLOBALS.progressInterval.terminate();
		// this.updateGlobals('progressInterval', null);
		$('#wait_progress').css('width', '100%');
	}
}

module.exports.isUndefined = isUndefined;
module.exports.updateGlobals = updateGlobals;
module.exports.dateToString = dateToString;
module.exports.dateToTimeString = dateToTimeString;
module.exports.dateToTimepickerString = dateToTimepickerString;
module.exports.stringToDate = stringToDate;
module.exports.stringToUTCDate = stringToUTCDate;
module.exports.getSerializedFormData = getSerializedFormData;
module.exports.getSerializedFormDataWithoutIgnore = getSerializedFormDataWithoutIgnore;
module.exports.setValueForInputWithDropDownField = setValueForInputWithDropDownField;
module.exports.getValueFromInputWithDropDownField = getValueFromInputWithDropDownField;
module.exports.setDatePickerDropDownValue = setDatePickerDropDownValue;
module.exports.setInputDropDownValue = setInputDropDownValue;
module.exports.setInputUnknownValue = setInputUnknownValue;
module.exports.setInputNotCollectedValue = setInputNotCollectedValue;
module.exports.setInputContinuingValue = setInputContinuingValue;
module.exports.setInputUnlimitedValue = setInputUnlimitedValue;
module.exports.setInputNotMeasurableValue = setInputNotMeasurableValue;
module.exports.arrayIntersect = arrayIntersect;
module.exports.calculateAge = calculateAge;
module.exports.round = round;
module.exports.dateToLocaleFormatString = dateToLocaleFormatString;
module.exports.dateToLocaleString = dateToLocaleString;
module.exports.dateToLocaleTimeString = dateToLocaleTimeString;
module.exports.dateToLocaleLongTimeString = dateToLocaleLongTimeString;
module.exports.getLocaleDateFormat = getLocaleDateFormat;
module.exports.getLocaleTimeFormat = getLocaleTimeFormat;
module.exports.getLocaleDateFormatMask = getLocaleDateFormatMask;
module.exports.getMomentFormat = getMomentFormat;
module.exports.getLocaleNumberString = getLocaleNumberString;
module.exports.stringToNumber = stringToNumber;
module.exports.numberToString = numberToString;
module.exports.setHtmlData = setHtmlData;
module.exports.setIDATData = setIDATData;
module.exports.isIDATField = isIDATField;
module.exports.isIDATFieldInDatabase = isIDATFieldInDatabase;
module.exports.isMatchFieldInDatabase = isMatchFieldInDatabase;
module.exports.isIDATInputField = isIDATInputField;
module.exports.isIDATRadioComboField = isIDATRadioComboField;
module.exports.isIDATDatePanelField = isIDATDatePanelField;
module.exports.isFormatValue = isFormatValue;
module.exports.htmlSpecialChars = htmlSpecialChars;
module.exports.getIgnoreFields = getIgnoreFields;
module.exports.getIgnoreFieldsNameArray = getIgnoreFieldsNameArray;
module.exports.getDecimalSeparator = getDecimalSeparator;
module.exports.getExaminationDateString = getExaminationDateString;
module.exports.getExaminationDateFormat = getExaminationDateFormat;
module.exports.complementDateString = complementDateString;
module.exports.setDatePickerValue = setDatePickerValue;
module.exports.isIgnoreFlagForIntegrityCheck = isIgnoreFlagForIntegrityCheck;
module.exports.isIgnoreFlagForIntegrityCheck = isIgnoreFlagForIntegrityCheck;
module.exports.unblockUI = unblockUI;
module.exports.blockUI = blockUI;
module.exports.getMaster = getMaster;
module.exports.getCourse = getCourse;
module.exports.getQuestionnaire = getQuestionnaire;
module.exports.detachMaster = detachMaster;
module.exports.appendMaster = appendMaster;
module.exports.detachCourse = detachCourse;
module.exports.appendCourse = appendCourse;
module.exports.detachQuestionnaire = detachQuestionnaire;
module.exports.appendQuestionnaire = appendQuestionnaire;
module.exports.detachTab = detachTab;
module.exports.appendTab = appendTab;
module.exports.showProgressbar = showProgressbar;
module.exports.hideProgressbar = hideProgressbar;
